import { Badge } from "@/components/ui/badge";
import { Activity, CheckCircle2, FileDown, ShieldCheck, Hash } from "lucide-react";

export function StatusBadge({ status }) {
  const finished = status === "finished";
  return (
    <Badge
      data-testid="session-status-badge"
      variant="outline"
      className={finished
        ? "border-emerald-300 bg-emerald-50 text-emerald-700"
        : "border-blue-300 bg-blue-50 text-blue-700"}
    >
      {finished ? <CheckCircle2 className="mr-1 h-3 w-3" /> : <Activity className="mr-1 h-3 w-3" />}
      {finished ? "Finalizada" : "En progreso"}
    </Badge>
  );
}

export function AttemptBadge({ n }) {
  return (
    <Badge data-testid="session-attempt-badge" variant="outline" className="border-slate-300 bg-slate-50 text-slate-600">
      <Hash className="mr-0.5 h-3 w-3" />Intento {n}
    </Badge>
  );
}

export function ExportedBadge({ exported }) {
  return (
    <Badge data-testid="session-exported-badge" variant="outline"
      className={exported ? "border-teal-300 bg-teal-50 text-teal-700" : "border-slate-200 bg-white text-slate-400"}>
      <FileDown className="mr-1 h-3 w-3" />{exported ? "Exportado" : "Sin exportar"}
    </Badge>
  );
}

export function AuditedBadge({ audited }) {
  return (
    <Badge data-testid="session-audited-badge" variant="outline"
      className={audited ? "border-violet-300 bg-violet-50 text-violet-700" : "border-slate-200 bg-white text-slate-400"}>
      <ShieldCheck className="mr-1 h-3 w-3" />{audited ? "Auditado" : "Sin auditar"}
    </Badge>
  );
}
